var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmptyStatePrivateAlbumAccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109px",
    height: "98px",
    viewBox: "0 0 109 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmptyStatePrivateAlbumAccess") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-access--Empty-state",
    transform: "translate(-134.000000, -250.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icEmptyStatePrivateAlbumAccess",
    transform: "translate(96.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0 L85,0 C97.7025492,-2.33342044e-15 108,10.2974508 108,23 L108,75 C108,87.7025492 97.7025492,98 85,98 L23,98 C10.2974508,98 1.55561363e-15,87.7025492 0,75 L0,23 C-1.55561363e-15,10.2974508 10.2974508,9.4388478e-15 23,7.10542736e-15 Z M37.125,34.0277778 C41.2257143,34.0277778 44.55,30.6761317 44.55,26.5416667 C44.55,22.4072017 41.2257143,19.0555556 37.125,19.0555556 C33.0242857,19.0555556 29.7,22.4072017 29.7,26.5416667 C29.7,30.6761317 33.0242857,34.0277778 37.125,34.0277778 Z M73.35495,39.4721224 C63.45495,39.4721224 58.50495,54.4443446 51.07995,54.4443446 C43.65495,54.4443446 43.6599,49.4536039 33.75495,49.4536039 C23.85495,49.4536039 18.9,69.4165669 18.9,69.4165669 L88.20495,69.4165669 C88.20495,69.4165669 83.25495,39.4721224 73.35495,39.4721224 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyStatePrivateAlbumAccess);
export default __webpack_public_path__ + "static/media/icEmptyStatePrivateAlbumAccess.94f8c376c75470f4978e0726614383e2.svg";
export { ForwardRef as ReactComponent };